export default {"src":"/_next/static/image/public/images/ic_no_slot_found.7bd095f1b4b77a17e961345fc3933a66.svg","height":115,"width":114};